import axios from 'axios';
import { API } from './api';

// Carrega a logo como dataURL (base64) uma única vez. jsPDF é mais confiável com dataURL
// do que com um caminho de arquivo direto.
let _logoPromise = null;
export function getLogoDataUrl() {
  if (!_logoPromise) {
    _logoPromise = fetch('/logo.png')
      .then((r) => r.blob())
      .then(
        (blob) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
          })
      )
      .catch(() => null);
  }
  return _logoPromise;
}

// Busca os dados da empresa (cabeçalho dos relatórios). Cacheado por sessão.
let _empresaPromise = null;
export function fetchEmpresa() {
  if (!_empresaPromise) {
    _empresaPromise = axios
      .get(`${API}/empresa`)
      .then((r) => r.data || {})
      .catch(() => ({}));
  }
  return _empresaPromise;
}
export function refreshEmpresaCache() {
  _empresaPromise = null;
}

export async function getPdfAssets() {
  const [logoDataUrl, empresa] = await Promise.all([getLogoDataUrl(), fetchEmpresa()]);
  return { logoDataUrl, empresa: empresa || {} };
}

export function addLogo(doc, logoDataUrl, x, y, w, h) {
  if (!logoDataUrl) return;
  try {
    doc.addImage(logoDataUrl, 'PNG', x, y, w, h);
  } catch (e) {
    console.warn('Logo opcional não pôde ser adicionada ao PDF:', e);
  }
}

// Desenha o bloco de dados da empresa (nome + até 3 linhas de contato).
// align: 'left' (padrão) ou 'right'.
export function drawCompanyBlock(doc, empresa = {}, x = 54, yStart = 13, opts = {}) {
  const align = opts.align || 'left';
  const nome = (empresa.nome || 'IDENTIDADE GENTE').toUpperCase();
  doc.setTextColor(28, 25, 23);
  doc.setFont(undefined, 'bold');
  doc.setFontSize(opts.nameSize || 12);
  doc.text(nome, x, yStart, { align });

  const linhas = [];
  if (empresa.cnpj) linhas.push(`CNPJ: ${empresa.cnpj}`);
  const contato = [empresa.telefone, empresa.email].filter(Boolean).join('  •  ');
  if (contato) linhas.push(contato);
  if (empresa.endereco) linhas.push(empresa.endereco);

  doc.setFont(undefined, 'normal');
  doc.setFontSize(8);
  doc.setTextColor(92, 84, 74);
  let cy = yStart + 5;
  linhas.slice(0, 3).forEach((l) => {
    doc.text(l, x, cy, { align });
    cy += 4;
  });

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
}

// Aplica uma marca-d'água sutil da logo (centralizada) em TODAS as páginas.
// Chamar logo antes de salvar o PDF.
export function applyWatermarkAllPages(doc, logoDataUrl) {
  if (!logoDataUrl || !doc.GState) return;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const size = Math.min(pageWidth, pageHeight) * 0.55;
  const x = (pageWidth - size) / 2;
  const y = (pageHeight - size) / 2;
  const total = doc.internal.getNumberOfPages();
  for (let i = 1; i <= total; i++) {
    try {
      doc.setPage(i);
      doc.saveGraphicsState();
      doc.setGState(new doc.GState({ opacity: 0.05 }));
      doc.addImage(logoDataUrl, 'PNG', x, y, size, size);
      doc.restoreGraphicsState();
    } catch (e) {
      console.warn('Marca-d\'água opcional não pôde ser aplicada ao PDF:', e);
    }
  }
}
